// file path: src\stores\auth.slice.ts

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SearchState } from '../types/disease.type';


interface ddCalculatorState {
  searchData: SearchState;
}

export const initialSearchData: SearchState = {
  symptoms: [],
  ag: null,
  sx: "",
  fh: ""
}
const initialState: ddCalculatorState = {
  searchData: initialSearchData
};

const slice = createSlice({
  name: 'dd-calculator',
  initialState,
  reducers: {
    updateSearchData: (state, action: PayloadAction<Partial<SearchState>>) => {
      state.searchData = { ...state.searchData, ...action.payload };
    },
    deleteSymptom: (state, action: PayloadAction<number>) => {
      const index = action.payload
      state.searchData.symptoms = state.searchData.symptoms.filter((_, idx) => idx !== index);
    }
  },
});

export const {
  updateSearchData,
  deleteSymptom
} = slice.actions;

const ddCalculatorReducer = slice.reducer;
export default ddCalculatorReducer
